import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { WHATSAPP_NUMBER } from 'shared/constants'
import { openExternalUrl } from 'shared/lib/external-open'

import s from './styles.module.scss'

export const MyOrdersSupport = () => {
  const { t } = useTranslation()

  const goToWhatsApp = () => {
    openExternalUrl(`https://wa.me/${WHATSAPP_NUMBER}`)
  }
  return (
    <div className={clsx('medium-12', s.container)}>
      <p className={s.title}>{t('my_orders_block.support.title')}</p>
      <p
        className={s.link}
        onClick={goToWhatsApp}
      >
        {t('my_orders_block.support.write')}
      </p>
    </div>
  )
}
